export default __webpack_public_path__ + "static/media/IMG_6322.1131869d.JPG";